'use client'
import * as React from 'react'
import { ThemeProvider as NextThemesProvider, useTheme } from 'next-themes'
import { isDarkTheme } from '@/lib/copy/themes'

// Tailwind's `dark:` variants only fire when the <html> element has
// the `dark` class. next-themes sets the active theme key as the
// class name, which alone isn't enough, so we mirror the active
// theme's mode onto a `dark` class, ensuring `dark:bg-foo` etc. keep
// working across every preset.
function ThemeSync() {
  const { resolvedTheme } = useTheme()
  React.useEffect(() => {
    if (!resolvedTheme) return
    const root = document.documentElement
    if (isDarkTheme(resolvedTheme)) root.classList.add('dark')
    else root.classList.remove('dark')
    root.style.colorScheme = isDarkTheme(resolvedTheme) ? 'dark' : 'light'
  }, [resolvedTheme])
  return null
}

export function ThemeProvider({ children, ...props }: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider {...props}>
      <ThemeSync />
      {children}
    </NextThemesProvider>
  )
}
